/**
 * Verfassung — Stufe, Smiley, Satz. (06.09.2026)
 *
 * Bis heute lebte das in app.ts als Kopfzeilen-Glut: ein Smiley neben dem
 * Namen, der den ganzen Tag traurig schaute, wenn die Erholung niedrig war
 * — auch dann, wenn Whoop den Tag noch gar nicht geliefert hatte. Martin:
 * „wenn der die ganze Zeit traurig schaut, ist das frustrierend … und wenn
 * es nicht aktuell ist, ausgegraut, weil er sonst vermittelt, dass es immer
 * noch so ist." Jetzt wohnt die Verfassung in der Körper-Karte im Zuhause,
 * mit Stand und Zeitpunkt. Hier steht nur die Rechnung.
 */
type Verfassungsstufe = "gut" | "mittel" | "niedrig" | "unbekannt";

export function stufeFuer(score: number | null | undefined): Verfassungsstufe {
  if (score == null || !Number.isFinite(score)) return "unbekannt";
  return score >= 67 ? "gut" : score >= 34 ? "mittel" : "niedrig";
}

export function smileySvg(stufe: Verfassungsstufe): string {
  const mund =
    stufe === "gut"
      ? '<path d="M5.3 9.6 Q8 12.1 10.7 9.6" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>'
      : stufe === "niedrig"
        ? '<path d="M5.3 11.2 Q8 9 10.7 11.2" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>'
        : '<path d="M5.6 10.5 L10.4 10.5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>';
  return (
    '<svg viewBox="0 0 16 16" width="28" height="28" aria-hidden="true">' +
    '<circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" stroke-width="1.5"/>' +
    '<circle cx="5.7" cy="6.1" r="0.95" fill="currentColor"/>' +
    '<circle cx="10.3" cy="6.1" r="0.95" fill="currentColor"/>' +
    mund +
    "</svg>"
  );
}

export function verfassungsZeile(stufe: Verfassungsstufe, defizitH: number | null | undefined): string {
  if (stufe === "unbekannt") return "";
  if (stufe === "niedrig" || (defizitH != null && defizitH <= -1.5)) return "Sei heute sanft mit dir.";
  if (stufe === "gut") return "Dein Körper trägt dich heute.";
  return "Ein ruhiger Gang ist heute genug.";
}
